<template>
  <ModalLayout :title="'Edit Dialog'">
    <div class="rounded-t-[10px] bg-white px-[24px] pt-[41px] sm:px-[40px]">
      <div
        @click.prevent="$emit('close')"
        class="absolute right-[24px] top-[36px] flex h-[32px] w-[32px] cursor-pointer items-center justify-center rounded-full border border-gpx_gray-800 sm:right-[40px]"
      >
        <XMarkIcon class="heroicon-stroke-w-1.4 h-[20px] w-[20px] text-gpx_gray-200" />
      </div>
      <div class="border-b border-b-gpx_gray-800 pb-[18px]">
        <div class="mb-[2px] text-sm font-medium text-gpx_gray-200">Editing</div>
        <div class="text-2xl font-semibold text-gpx_black-100">
          {{ dialog?.title || 'Untitled Conversation' }}
        </div>
      </div>
      <div class="mt-[35px] flex flex-col gap-y-[27px]">
        <UIInput
          placeholder="Enter dialog title"
          label="Dialog Title"
          :value="form.title"
          v-model="form.title"
        />
      </div>
    </div>
    <div class="rounded-b-[10px] bg-white pt-[40px] sm:pt-[64px]">
      <Button
        size="modal"
        class="w-full"
        @click="handleSave"
        :disabled="isSaving"
        :loading="isSaving"
      >
        <template v-if="isSaving">Saving</template>
        <template v-else>Save Changes</template>
      </Button>
    </div>
  </ModalLayout>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { XMarkIcon } from '@heroicons/vue/24/outline';
import ModalLayout from '@/layouts/ModalLayout.vue';
import UIInput from '@/components/ui/UIInput.vue';
import { updateAiDialog } from '@gpx-spa/queries';
import {COMMON_SAVE_SUCCESS} from "@/config/constants";
import {useToast} from "vue-toastification";

const props = defineProps({
  params: {
    type: Object,
    required: true
  }
});

const emit = defineEmits(['close']);

const store = useStore();
const accountId = store.getters['auth/accountId'];
const isSaving = ref(false);
const form = ref({
  title: ''
});

const dialog = computed(() => props.params.dialog);

// Initialize form with current dialog title
form.value.title = dialog.value?.title || '';
const toast = useToast();
const updateDialog = updateAiDialog(accountId);

function handleSave() {
  if (!form.value.title.trim()) {
    return;
  }

  isSaving.value = true;
  updateDialog.mutate(
    { id: dialog.value.id, title: form.value.title },
    {
      onSuccess: () => {
        if (typeof props.params.onSuccess === 'function') {
          props.params.onSuccess()
        }
        toast.success(COMMON_SAVE_SUCCESS)
        emit('close');
      },
      onError: (error) => {
        console.error('Failed to update dialog:', error);
        toast.success('Failed to update dialog')
      },
      onSettled: () => {
        isSaving.value = false;
      }
    }
  );
}
</script>
